var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499",
    transform: "translate(-2808 -365.262)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 16,
    height: 16,
    transform: "translate(2808 365.262)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M2816,366.762a6.5,6.5,0,1,0,6.5,6.5A6.5,6.5,0,0,0,2816,366.762Zm3.9,5.55-4.085,4.085a1.019,1.019,0,0,1-1.438,0l-2.267-2.268a.966.966,0,0,1,.684-1.649h0a.961.961,0,0,1,.684.284l1.618,1.617,3.437-3.436a1.018,1.018,0,0,1,1.367,0A.969.969,0,0,1,2819.9,372.312Z",
    fill: "#18c99d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActive);
export default __webpack_public_path__ + "static/media/icon-active.0e969521b2efdbd6996aaf20dc589b86.svg";
export { ForwardRef as ReactComponent };